var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',_vm._b({attrs:{"value":_vm.value,"rules":_vm.required ? [function (v) { return !!v || this$1.$attrs.label + ' is required'; }] : []},on:{"keydown":function($event){$event.stopPropagation();},"input":function($event){return _vm.$emit('update:value', $event)}}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }